import { Button } from '@iwoca/orion';
import classnames from 'classnames';

import styles from './FinishStepButton.module.css';

type FinishStepButtonProps = {
    type?: 'button' | 'submit' | 'reset';
    onClick: () => void;
    explainerText: string;
    containerClassName?: string;
    children?: JSX.Element;
    className?: string;
    disabled?: boolean;
};
const FinishStepButton = ({
    type,
    onClick,
    explainerText,
    containerClassName,
    children,
    className,
    disabled
}: FinishStepButtonProps) => (
    <div
        className={classnames(
            styles.finishStepButtonContainer,
            containerClassName
        )}>
        {explainerText ? (
            <div className={styles.explainer}>{explainerText}</div>
        ) : null}

        <Button
            onClick={onClick}
            type={type}
            data-testid="finish-step-button"
            disabled={disabled}
            className={classnames(styles.finishStepButton, className)}>
            {children}
        </Button>
    </div>
);

export default FinishStepButton;
